import moment from 'moment';
import { types as actionTypes } from './criteriaActions';
import { Action } from '../../../types';
import {
  WaiverWorkItemSearchCriteria,
  WaiverWorkItemsListType,
} from '../../../../types/waiverWorkItem';
import _ from 'lodash';

export type WaiverWorkItemSearchCriteriaState = {
  [key in WaiverWorkItemsListType]: WaiverWorkItemSearchCriteria;
};

const initialState: WaiverWorkItemSearchCriteriaState = {
  ACTIVE_WORK_ITEMS: {
    listType: 'ACTIVE_WORK_ITEMS',
    state: 'OPEN',
  },
  HISTORICAL_WORK_ITEMS: {
    listType: 'HISTORICAL_WORK_ITEMS',
    state: 'CLOSED',
    dateRange: {
      startDate: moment().subtract(29, 'days'),
      endDate: moment(),
    },
  },
};

export default function reducer(
  state: WaiverWorkItemSearchCriteriaState = initialState,
  action: Action<WaiverWorkItemSearchCriteria>,
): WaiverWorkItemSearchCriteriaState {
  switch (action.type) {
    case actionTypes.LOAD_SUCCESS:
      if (action.response) {
        return {
          ...state,
          [action.response.listType]: action.response,
        };
      }
      return _.cloneDeep(state);
    default:
      return _.cloneDeep(state);
  }
}
